module.exports = __webpack_public_path__ + "static/media/15.0a18b14d.jpg";